module.exports = __webpack_public_path__ + "statics/img/cate4-6@2x.b645122c.png";